import ApiCalls from "@/components/utils/api.calls.js"


export default {
    data: function() {
        return {
            config: {},
            config_promise: null,
        }
    },
    methods: {
        loadConfig: function() {
            // Awaitable so a caller that reads `config` cannot run before it is filled.
            if(!this.config_promise) {
                this.config_promise = ApiCalls.getConstanceConfig()
                    .then(response => {
                        this.config = response.data;
                        return this.config;
                    })
                    .catch(error => {
                        console.error(error);
                        return this.config;
                    })
            }
            return this.config_promise;
        },
    },
    mounted() {
        this.loadConfig();
    },
}
